const container = document.querySelector('.js-gaz-simulation');
const opener = document.querySelector('.js-gaz-simulation-open');
const closer = document.querySelector('.js-gaz-simulation-close');
const form = document.querySelector('.js-gaz-simulation-search-form');
const input = document.querySelector('.js-gaz-simulation-search-input');
const loader = document.querySelector('.loading-spinner');
const results = document.querySelector('.js-gaz-simulation-results');

const GazSimulation = {
	init() {
		if (!container) return;

		document.addEventListener('click', (e) => {
			if (opener.contains(e.target)) {
				GazSimulation.showSimulation();
			}
			if (closer.contains(e.target)) {
				GazSimulation.resetSimulation();
			}
		});

		// Gestion click interpellation mairie + plausible
		document.querySelector(".js-gaz-simulation-mailto").addEventListener('click', (e) => {
			e.preventDefault();
			
			// Plausible event
			const ville = e.target.parentElement.className.split(' ').find(c => c.startsWith('plausible-event-ville='));
			if (ville) {
				const villeName = ville.split('=')[1];
				// Si plausible est défini
				if (typeof plausible === 'function')
					plausible('Bouton interpellation mairie', { props: { ville: villeName } });
			}

			window.open(e.target.parentElement.href, '_blank');

		});

		form.addEventListener('submit', (e) => {
			e.preventDefault();
		});

		// Onkeyup sur input
		input.addEventListener('keyup', (e) => {
			// Si la saisie fait au moins 3 caractères
			if (e.target.value.trim().length < 3) {
				return;
			}

			// On met en place un debounce pour éviter de spammer les requêtes
			if (this.debounceTimeout) {
				clearTimeout(this.debounceTimeout);
			}
			this.debounceTimeout = setTimeout(() => {
				GazSimulation.listCities(e.target.value.trim());				
			}, 300);
		});
	},

	listCities(recherche) {
		fetch(ajaxObject.ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			},
			body: new URLSearchParams({
				action: 'recherche_ville',
				recherche: recherche,
				nonce: ajaxObject.nonce,
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				// Traiter les données reçues
				GazSimulation.listSuggestions(data.data);
			})
			.catch((error) => {
				console.error('Erreur:', error);
			});
	},

	listSuggestions(suggestions) {
		const suggestionsList = document.querySelector('.js-gaz-simulation-suggestions');
		suggestionsList.innerHTML = '';

		suggestions.forEach((city) => {
			const li = document.createElement('li');
			const a = document.createElement('a');
			a.href = '#';
			a.textContent = city.nom_commune;
			a.classList.add('block', 'px-4', 'py-2', 'hover:bg-gray-100');
			li.appendChild(a);
			suggestionsList.appendChild(li);

			a.addEventListener('click', (e) => {
				e.preventDefault();
				input.value = city.nom_commune;
				suggestionsList.innerHTML = '';
				suggestionsList.classList.add('hidden');

				const nodataElems = document.getElementsByClassName('js-gaz-simulation-nodata');
				const hasdataElems = document.getElementsByClassName('js-gaz-simulation-hasdata');
				const scoreContainer = document.querySelector('.js-gaz-simulation-score-container');
				const quartileConsoVilleElems = document.getElementsByClassName('js-gaz-simulation-quartiles');
				const villeArrondissementElems = document.getElementsByClassName('js-gaz-simulation-arrondissement');

				if (quartileConsoVilleElems) {
					Array.from(quartileConsoVilleElems).forEach(elem => {
						elem.classList.add('hidden');
					});
				}

				if( villeArrondissementElems) {
					Array.from(villeArrondissementElems).forEach(elem => {
						elem.classList.add('hidden');
					});
				}

				if(
					city["conso_totale_Gaz_MWh"] === null ||
					city["cout_gaz_par_hab_(€/hab)"] === null ||
					city["POUTIN_cout_gaz_par_hab_(€/hab)"] === null ||
					city["TRUMP_cout_gaz_par_hab_(€/hab)"] === null
				){
					if (nodataElems) {
						Array.from(nodataElems).forEach(elem => {
							elem.classList.remove('hidden');
						});
					}
					if (hasdataElems) {
						Array.from(hasdataElems).forEach(elem => {
							elem.classList.add('hidden');
						});
					}
					if(scoreContainer){
						scoreContainer.classList.add('hidden');
					}
				}else{
					// On affiche le message "avec données"
					const nodataElems = document.getElementsByClassName('js-gaz-simulation-nodata');
					const hasdataElems = document.getElementsByClassName('js-gaz-simulation-hasdata');
					if (nodataElems) {
						Array.from(nodataElems).forEach(elem => {
							elem.classList.add('hidden');
						});
					}
					if (hasdataElems) {
						Array.from(hasdataElems).forEach(elem => {
							elem.classList.remove('hidden');
						});
					}
					if(scoreContainer){
						scoreContainer.classList.remove('hidden');
					}

					// Si city.is_arrondissement est true, on affiche les éléments spécifiques
					if(city.is_arrondissement){
						if( villeArrondissementElems) {
							Array.from(villeArrondissementElems).forEach(elem => {
								elem.classList.remove('hidden');
							});
						}

						// On supprime xxx arrondissement du nom de la commune
						city.nom_commune = city.nom_commune.replace(/\s+\d{1,2}(er|e)?\s+arrondissement$/i, '');

						// On met à jour le nom de la ville dans le conteneur spécifique
						document.querySelector(".js-gaz-simulation-arrondissement--ville").textContent = city.nom_commune;
					}

					// On met à jour les résultats de la simulation
					const nomCommuneElem = document.getElementsByClassName('js-gaz-simulation-nom-communue');
					const prixCommuneElem = document.getElementById('js-gaz-simulation-prix-commune');
					const trumpPoutineElem = document.getElementsByClassName('js-gaz-simulation-trump-poutine');
					const equivalentVoituresElem = document.getElementsByClassName('js-gaz-simulation-equivalent-voitures-thermiques');
					const quartileConsoVille = city.quartile_sur_communes_ayant_declare_du_gaz.toLowerCase();
					const quartileConsoVilleElem = document.querySelector('.js-gaz-simulation-' + quartileConsoVille);
					if (quartileConsoVilleElem) {
						quartileConsoVilleElem.classList.remove('hidden');
					}
					
					if (equivalentVoituresElem) {
						Array.from(equivalentVoituresElem).forEach(elem => {
							elem.textContent = Math.round((Math.round(city["conso_totale_Gaz_MWh"]) * 1000 * 0.215) / 2993);
						});
					}
					if (trumpPoutineElem) {
						Array.from(trumpPoutineElem).forEach(elem => {
							elem.textContent = Math.round(city["POUTIN_cout_gaz_par_hab_(€/hab)"] + city["TRUMP_cout_gaz_par_hab_(€/hab)"]) + "€";
						});
					}
					if (nomCommuneElem) {
						Array.from(nomCommuneElem).forEach(elem => {
							elem.textContent = city.nom_commune;
						});
					}
					if (prixCommuneElem) {
						prixCommuneElem.textContent = Math.round(city["cout_gaz_par_hab_(€/hab)"]) + "€";
					}
				}

				GazSimulation.updateMailto(city);
				GazSimulation.hideResults();
				GazSimulation.runSimulation();
			});
		});

		if (suggestions.length > 0) {
			suggestionsList.classList.remove('hidden');
		} else {
			suggestionsList.classList.add('hidden');
		}
	},

	updateMailto(city) {
		const mailtoContainer = document.querySelector('.js-gaz-simulation-mailto-container');
		if(city.mail !== null || city.form !== null){
			// on affiche le conteneur
			if (mailtoContainer) {
				mailtoContainer.style.display = 'flex';
			}
			// On met à jour le lien mailto
			const mailtoLink = document.querySelector('.js-gaz-simulation-mailto');
			if (mailtoLink) {
				// On met à jour la class plausible-event-ville={ville} par le nom de la ville
				const villeFormatee = city.nom_commune.trim().replace(/\s+/g, '+');
				// Récupère la classe existante
				const classes = mailtoLink.className.split(' ');
				// Supprime l’ancienne classe plausible-event-ville=...
				const nouvellesClasses = classes.filter(c => !c.startsWith('plausible-event-ville='));
				// Ajoute la nouvelle
				nouvellesClasses.push(`plausible-event-ville=${villeFormatee}`);
				// Met à jour la liste des classes
				mailtoLink.className = nouvellesClasses.join(' ');

				// Si un formulaire est fourni, on utilise ce lien
				if(city.form !== null){
					mailtoLink.href = city.form;
				}else{
					// On construit le lien mailto
					const subject = encodeURIComponent(`Municipales 2026 : Objectif ${city.nom_commune} sans gaz fossile ?`);
					const emailAddress = city.mail;
					let body = 
					encodeURIComponent(`Bonjour,\n
Habitant à ${city.nom_commune}, je souhaite attirer votre attention sur la nécessité pour notre commune de sortir du gaz fossile.\n
Le gaz « naturel », souvent présenté comme une énergie de transition, contribue en réalité fortement au réchauffement climatique, met en danger notre santé (pollution de l’air, asthme des enfants), pèse lourd sur nos factures et fragilise notre souveraineté énergétique.\n
À ${city.nom_commune}, le gaz fossile coûte ${Math.round(city["cout_gaz_par_hab_(€/hab)"])} € par habitant·e. Sa consommation émet annuellement autant de gaz à effet de serre que ${Math.round((Math.round(city["conso_totale_Gaz_MWh"]) * 1000 * 0.215) / 2993)} voitures thermiques.\n
Bonne nouvelle : des solutions existent, et plusieurs communes en France ont déjà montré l’exemple — rénovation des bâtiments publics (écoles, hôpitaux, crèches...), passage à des modes de chauffage plus propres et plus économiques, qui se traduisent par une nette réduction des factures énergétiques.\n
Je vous enjoins à faire de la sortie du gaz un engagement fort de votre programme municipal et à inscrire la transition énergétique locale au cœur de votre action pour les années à venir.\n
Je souhaiterais connaître les mesures que vous envisagez pour réduire la dépendance au gaz dans notre commune et je suivrai de près leur mise en place.\n
Merci pour votre attention et pour votre engagement en faveur d’un avenir plus sobre, plus sain et plus résilient.\n
Cordialement,
[Prénom Nom]`
					);
					mailtoLink.href = `mailto:${emailAddress}?subject=${subject}&body=${body}`;
				}
			}
		} else {
			// Si pas d'email trouvé, on masque le conteneur
			if (mailtoContainer) {
				mailtoContainer.style.display = 'none';
			}
		}
	},

	showSimulation() {
		this.toggleVisibility(container, true, '0.3s', true);
		opener.parentElement.classList.add('hidden');
	},

	hideSimulation() {
		this.toggleVisibility(container, false, '0.1s');
		opener.parentElement.classList.remove('hidden');
	},

	showResults() {
		this.expandSection(results);
	},

	hideResults() {
		this.toggleVisibility(results, false, '0.1s');
		if (!results.classList.contains('hidden')) {
			results.classList.add('hidden');
		}
		results.removeAttribute('style');
	},

	showLoader() {
		loader.classList.remove('hidden');
	},

	hideLoader() {
		if (!loader.classList.contains('hidden')) {
			loader.classList.add('hidden');
		}
	},

	runSimulation() {
		this.hideResults();
		this.showLoader();
		setTimeout(() => {
			this.hideLoader();
			this.showResults();
			setTimeout(() => {
				this.scrollToResults();
			}, 150);
		}, 1250);
	},

	resetSimulation() {
		this.hideSimulation();
		this.hideResults();
		this.hideLoader();
		input.value = '';
	},

	toggleVisibility(element, show, duration = '.3s', slide = false) {
		if (!element) return;

		if (slide) {
			element.style.transition = `opacity ${duration} ease, transform ${duration} ease`;
			element.style.transformOrigin = 'top';

			if (show) {
				element.classList.remove('hidden');
				element.style.display = 'block';
				element.style.opacity = '0';
				element.style.transform = 'translateY(24px)';

				requestAnimationFrame(() => {
					element.style.opacity = '1';
					element.style.transform = 'translateY(0)';
				});
			} else {
				element.style.opacity = '0';
				element.style.transform = 'translateY(24px)';
				element.addEventListener(
					'transitionend',
					() => {
						element.classList.add('hidden');
						element.removeAttribute('style');
					},
					{ once: true }
				);
			}
			return;
		}

		// comportement standard pour les autres éléments
		element.style.transition = `opacity ${duration} ease`;
		if (show) {
			element.classList.remove('hidden');
			requestAnimationFrame(() => (element.style.opacity = 1));
		} else {
			element.style.opacity = 0;
			element.addEventListener(
				'transitionend',
				() => {
					element.classList.add('hidden');
					if (!element.classList.contains('js-gaz-simulation-results')) {
						element.removeAttribute('style');
					} else {
						element.style.transform = '0';
						element.style.transition = '';
					}
				},
				{ once: true }
			);
		}
	},

	expandSection(element) {
		element.classList.remove('hidden');
		element.style.display = 'block';
		element.style.overflow = 'hidden';
		element.style.height = '0px';
		element.style.opacity = '0';
		element.style.transition = 'height 1s ease, opacity 1s ease';

		const targetHeight = element.scrollHeight + 'px';

		requestAnimationFrame(() => {
			element.style.height = targetHeight;
			element.style.opacity = '1';
		});

		element.addEventListener(
			'transitionend',
			(e) => {
				if (e.propertyName !== 'height') return;
				element.style.height = '';
				element.style.overflow = '';
				element.style.opacity = '1';
				element.style.transition = '';
			},
			{ once: true }
		);
	},

	scrollToResults() {
		const targetTop =
			document.querySelector('.js-gaz-simulation-results-anchor').getBoundingClientRect()
				.top + window.scrollY;

		window.scrollTo({
			top: targetTop,
			behavior: 'smooth',
		});
	},
};

export default GazSimulation;
